<template>
  <div
    class="mc-sheetmask"
    :class="{ 'is-open': open }"
    @click.self="$emit('close')"
  >
    <div class="mc-sheet">
      <div class="mc-grab" />
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BottomSheet',
  props: {
    open: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
.mc-sheetmask {
  position: absolute;
  inset: 0;
  background: rgba(20, 20, 43, 0.42);
  z-index: 20;
  display: none;
  align-items: flex-end;
}

.mc-sheetmask.is-open {
  display: flex;
  animation: mc-fade 0.2s;
}

@keyframes mc-fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.mc-sheet {
  width: 100%;
  background: #fff;
  border-radius: 20px 20px 0 0;
  padding: 8px 20px calc(18px + env(safe-area-inset-bottom, 0px));
  max-height: 88%;
  overflow-y: auto;
  animation: mc-up 0.28s cubic-bezier(0.22, 0.7, 0.3, 1);
}

@keyframes mc-up {
  from {
    transform: translateY(100%);
  }
  to {
    transform: none;
  }
}

.mc-grab {
  width: 40px;
  height: 4px;
  border-radius: 2px;
  background: #d9dbe9;
  margin: 6px auto 14px;
}
</style>
